import type { ReactNode } from 'react';

export function EditorField({ label, children }: { label: ReactNode; children: ReactNode }) {
  return (
    <div className="flex items-center gap-2.5 mb-2">
      <span className="text-[11px] font-semibold text-ink-3 min-w-[110px] flex-shrink-0">{label}</span>
      {children}
    </div>
  );
}

/** Styled select matching viewer's .ed-select */
export function EdSelect({
  value,
  onChange,
  options,
  className = '',
}: {
  value: string;
  onChange: (v: string) => void;
  options: readonly string[] | { value: string; label: string }[];
  className?: string;
}) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`flex-1 bg-surface border border-glass-border rounded-lg px-3 py-2 text-sm font-mono text-ink outline-none transition-all duration-200 focus:border-orange focus:shadow-[0_0_8px_rgba(249,115,22,0.15)] cursor-pointer appearance-none ${className}`}
    >
      {options.map((opt) => {
        const v = typeof opt === 'string' ? opt : opt.value;
        const l = typeof opt === 'string' ? opt : opt.label;
        return <option key={v} value={v}>{l}</option>;
      })}
    </select>
  );
}

/** Styled number/text input matching viewer's .ed-input */
export function EdInput({
  value,
  onChange,
  type = 'number',
  placeholder,
  small,
  step,
  min,
  max,
  className = '',
}: {
  value: string | number;
  onChange: (v: string) => void;
  type?: 'number' | 'text';
  placeholder?: string;
  small?: boolean;
  step?: string;
  min?: string;
  max?: string;
  className?: string;
}) {
  const defaultPlaceholder = placeholder ?? (type === 'number' ? '0' : 'Enter value');
  return (
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={defaultPlaceholder}
      step={step}
      min={min}
      max={max}
      className={`bg-surface border border-glass-border rounded-lg px-3 py-2 text-sm font-mono text-ink outline-none transition-all duration-200 focus:border-orange focus:shadow-[0_0_8px_rgba(249,115,22,0.15)] placeholder:text-ink-4 ${
        small ? 'w-[80px] flex-none' : 'flex-1'
      } ${className}`}
    />
  );
}
